import { dispatch, pathSubscription } from 'nike-re-framejs';
import onbClient from '../../../registration/util/client';
import { handleServerErrors } from '../../../registration/util/error';
import { fromJS } from 'immutable';

export function loadKycForm(updateForm) {
    onbClient
        .get('/post/kyc-form')
        .then(kycform => dispatch(setKycForm(kycform, updateForm)))
        .catch(handleServerErrors());
}

export function loadDefaultKycForm(type, version) {
    onbClient
        .get('/post/kyc-form/default?type=' + type)
        .then(kycform => dispatch(setKycForm(kycform, true)))
        .catch(handleServerErrors());
}

export const setKycForm = (kyc, updateForm) => db =>
    db.setIn(['onboarding', 'kycForm'], fromJS(kyc)).setIn(['onboarding', 'updateForm'], updateForm);

export const kycForm$ = pathSubscription(['onboarding', 'kycForm']);
